module.exports = __webpack_public_path__ + "create_project.abe8981e.webm";